import TextLink from '../components/TextLink';
import { motion } from "framer-motion"


const MobileFooter = (props) => {
    return (
        <motion.div className='is-size-7 columns is-mobile'{...props.framer.slide}>
            <div className='column is-6'>
                 Drifting is a generative art series by Simon De Mai. More on <TextLink href="https://twitter.com/simondemai">Twitter</TextLink>.
            </div>
            <div className='column is-6'>
                Launching soon on ArtBlocks, NFT drop date not yet announced.
            </div>

        
        </motion.div>
    )
}

export default MobileFooter;